<script setup lang="ts">
import { computed, provide, unref, useId } from "vue";

export interface AccordionProps {
  /** Whether if there should be a divider around the items or not. */
  divider?: boolean;
  /** The */
  name?: string;
  size?: "small" | "medium";
  type?: "single" | "multiple";
}

const { divider = false, name, size = "medium", type = "single" } = defineProps<AccordionProps>();

// The prop 'name' is used to connect multiple <details> elements with only one open at a time.
// see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/details for details
const computedName = computed(() =>
  type === "single" ? name || `accordion-${useId()}` : undefined,
);

provide("accordionContext", { divider, name: unref(computedName), size });
</script>

<template>
  <slot />
</template>
